// extracted by mini-css-extract-plugin
export default {"root":"AnswerEditor_root__FEcf3","bottom":"AnswerEditor_bottom__Lw30X"};